import gsap from 'gsap'
import React, {useEffect, useRef} from 'react'

export const Loader = ({onComplete}) => {
  const loaderRef = useRef(null)
  const counterRef = useRef(null)
  const labelRef = useRef(null)

  useEffect(() => {
    const loaderTl = gsap.timeline({
      delay: 0.5,
      onComplete,
    })

    loaderTl
      .to(
        [labelRef.current, counterRef.current],
        {
          duration: 0.7,
          y: 0,
          opacity: 1,
          ease: 'power3.out',
          stagger: 0.15,
        },
        'start'
      )
      .to(
        counterRef.current,
        {
          innerText: 0,
          duration: 5,
          ease: 'expo.inOut',
          modifiers: {
            innerText: function (num) {
              num = Math.round(num)
              return String(num).padStart(2, '0')
            },
          },
        },
        'start+=0.3'
      )
      .to(
        loaderRef.current,
        {
          scaleY: 0,
          ease: 'expo.inOut',
          duration: 1.2,
        },
        '-=1'
      )
      .to(
        [labelRef.current, counterRef.current],
        {
          duration: 0.7,
          y: 40,
          opacity: 0,
          ease: 'power3.inOut',
          stagger: 0.05,
        },
        '-=1'
      )
  })

  return (
    <div className='pointer-events-none fixed inset-0 z-50 flex  items-end justify-start overflow-hidden  p-4 text-white'>
      <div className='relative z-[1] flex flex-col gap-[14px]'>
        <div className='label-s-v2'>
          <div className='translate-y-[100px] opacity-0' ref={labelRef}>
            Get ready for the retail renaissance
          </div>
        </div>
        <div className='heading-xl-v2 '>
          <div className='translate-y-[100px] opacity-0' ref={counterRef}>
            99
          </div>
        </div>
      </div>
      <div className='absolute inset-0 origin-bottom bg-greyv2-900' ref={loaderRef}></div>
    </div>
  )
}
